<template>
  <div class="weekly-variables-summary card-box">
    <div class="card-content current-week">
      <div class="last-updated">מעודכן ל-{{ lastUpdated }}</div>
      <div class="title">
        כמה כסף נשאר להוציא על הוצאות משתנות השבוע?
      </div>
      <div class="remaining-variables" :class="{ positive: hasRemainingVariables, zero: !hasRemainingVariables}">
        <animated-number :value="remainingVariables"></animated-number> ₪
      </div>
    </div>
    <div class="next-week-remaining" v-if="showNextWeek">
      <div class="card-content next-week">
        <div>הוצאות משתנות של שבוע הבא&nbsp;</div>
        <div class="next-week-amount">{{ formatAmountWithFractionAndCurrency(nextWeekRemainingVariables)}}</div>
      </div>
    </div>
    <variables-explanation/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import TransactionDisplayUtils from '../../generic-components/TransactionDisplayUtils.vue';
import cashflowViewConsts from '../../../../../../../../constants/cashflow-view';
import AnimatedNumber from '../../../../../../../../base-components/AnimatedNumber.vue';
import VariablesExplanation from './VariablesExplanation.vue';

export default {
  name: 'WeeklyVariablesSummary',
  mixins: [TransactionDisplayUtils],
  components: {
    AnimatedNumber,
    VariablesExplanation,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapGetters('cashflowView', ['isPredictedIncome', 'budgetUpdatedAt']),
    lastUpdated() {
      const updateHour = moment(this.budgetUpdatedAt).format('H:mm');
      const updateDate = moment(this.budgetUpdatedAt).format('D.M.YY');
      return `${updateHour}, ${updateDate}`;
    },
    weeks() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.variableExpense].weekly.realExpenses.categories;
    },
    currentWeek() {
      return _.find(this.weeks, w => w.timeFrameDetails.isCurrentWeek);
    },
    hasNextWeek() {
      return this.currentWeek.weekIndex < this.weeks.length - 1;
    },
    showNextWeek() {
      return this.hasNextWeek && this.remainingVariables <= 0;
    },
    remainingVariables() {
      return this.currentWeek.remaining;
    },
    nextWeekRemainingVariables() {
      return this.hasNextWeek ? this.weeks[this.currentWeek.weekIndex + 1].remaining : 0;
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .weekly-variables-summary {
    margin-bottom: 16px;

    .current-week {
      flex-direction: column;
    }

    .next-week {
      flex-direction: row;
    }

    .card-content {
      padding: 18px;
      display: flex;

    }

    .last-updated {
      font-size: 10px;
      color: $riseup_gray_2;
    }

    .title {
      margin-bottom: 6px;
      color: $riseup_black;
      font-family: GretaSans;
      font-size: 24px
    }

    .remaining-variables {
      font-size: 46px;
      color: $riseup_black;
      margin: 16px 0px 2px 0px;

      &.positive {
        color: $riseup_green;
        font-weight: bold;
      }
      &.zero {
        color: $riseup_black;
      }
    }

    .next-week-remaining {
      border-top: solid 1px $riseup_gray_1;
      font-size: 16px;
      color: $riseup_black;
    }

    .next-week-amount {
      font-weight: bold;
    }
  }

</style>
